@if (showPreviewBanner()) {
  <ngx-banner [type]="bannerType.Warning" [dismissable]="true" (onBannerDismissed)="dismissBanner()">
    <span class="ngx-banner-label">{{ 'activity-view_preview-banner_label' | translate }}</span>
    <span class="ngx-banner-message">{{ 'activity-view_preview-banner_message' | translate }}</span>
  </ngx-banner>
}

@if (activityNotAvailable()) {
  <ngx-zero-state class="zero-state-activity-not-available">
    <p zero-state-title translate="activity-view_zero-state-activity-not-available-title"></p>
    <p
      zero-state-subtext
      translate="activity-view_zero-state-activity-not-available-subtext"
      [translateParams]="{date: getActivityAvailableAt() | date: 'mediumDate'}"
    ></p>
    <div zero-state-graphic-bottom>
      <img [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="No Results">
    </div>
  </ngx-zero-state>
} @else if (ngxActivityService.showBuildingActivityZeroState$ | async) {
  <ngx-zero-state class="zero-state-building-activity-tasks">
    <p zero-state-title>
      <span class="ficon-spinner ficon-spin"></span>
      <span translate="activity-task-view_conversion-title"></span>
    </p>
    <div zero-state-graphic-bottom>
      <img [src]="activeBrandService.getImage('astronaut-astroid.svg')" alt="No Results">
    </div>
  </ngx-zero-state>
} @else if (ngxTaskService.shouldShowTasksObservable() | async) {
  <!-- Show task view content if tasks are enabled and show_tasks is true -->
  <div class="task-view-container">
    <div class="left-pane" #leftPane (scroll)="onLeftPaneScroll()">
      @if ((selectedOption$ | async) === TASK_VIEW_OPTIONS.OVERVIEW) {
        <activity-navigation (navigationSelected)="onNavigationSelected()"></activity-navigation>
      } @else {
        <activity-task-overview></activity-task-overview>
        <activity-task-pane
          #activityTaskPane
          [isEditMode]="isEditMode"
          (taskSelected)="onTaskSelected()">
        </activity-task-pane>
      }
      @if (hasReviewerRoleOrHigher()) {
        <pill-toggle
          [options]="pillToggleOptions"
          [selectedOption]="selectedOption$ | async"
        (onOptionSelect)="onOptionSelect($event)"></pill-toggle>
      }
    </div>
    <div class="right-pane" #rightPane>
      <!-- Dashboard -->
      <router-outlet (activate)="onRouteActivate()"></router-outlet>

      @if (hasReviewerRoleOrHigher()) {
        <pill-toggle
          [options]="pillToggleOptions"
          [selectedOption]="selectedOption$ | async"
        (onOptionSelect)="onOptionSelect($event)"></pill-toggle>
      }
    </div>

    @if (showArrow$ | async) {
      <div class="task-divider-arrow" [style.top.px]="arrowPosition$ | async">
        <div class="arrow-pointer"></div>
      </div>
    }
  </div>
} @else {
  <!-- Show old filter-view-layout if tasks are disabled or show_tasks is false -->
  <div class="tools-mobile">
    @if ((activityLoaded$ | async) && shouldShowFeedbackHold()) {
      <feedback-hold></feedback-hold>
    }
    <session-list-search-result-info></session-list-search-result-info>
    <session-search></session-search>
  </div>

  @if ((activityLoaded$ | async) === false) {
    <div class="loading-thumbnail">
      <loading [width]="'70px'" [height]="'70px'"></loading>
    </div>
  }
  @if ((currentView$ | async); as currentView) {
    <filter-view-layout
      id="activity-view-container"
      class="layout"
      #activityContainer>
      <div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
        <div class="filter-view" [formGroup]="form">
          @if (shouldShowScoreFilter()) {
            <div class="filter-container score-filter">
              <mat-form-field goSelect>
                <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
                <mat-select
                  formControlName="scoreFilter"
                  disableOptionCentering
                  panelClass="offsetPanel">
                  @for (option of scoreOptions; track option) {
                    <mat-option
                      [value]="option">
                      {{ scoreFilterTranslations[option] | translate }}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
              </mat-form-field>
            </div>
          }

          @if (shouldShowMinePeerFilter()) {
            <div class="filter-container mine-peer-filter">
              <mat-form-field goSelect>
                <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
                <mat-select
                  formControlName="minePeerFilter"
                  disableOptionCentering
                  panelClass="offsetPanel">
                  @for (option of minePeerOptions; track option) {
                    <mat-option
                      [value]="option">
                      {{ minePeerTranslations[option] | translate }}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
              </mat-form-field>
            </div>
          }

          <div class="sort-container">
            <mat-form-field goSelect>
              <mat-label>{{ 'common_sort-by' | translate }}</mat-label>
              <mat-select
                formControlName="sortBy"
                disableOptionCentering
                panelClass="offsetPanel">
                @for (option of sortByOptions; track option) {
                  <mat-option
                    [value]="option">
                    {{ sortOrderTranslations[option] | translate }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div class="tools-desktop-tablet" [ngClass]="{ 'no-feedback-hold': !shouldShowFeedbackHold() }">
          @if ((activityLoaded$ | async) && shouldShowFeedbackHold()) {
            <feedback-hold></feedback-hold>
          }
          <div class="search-container">
            <session-list-search-result-info></session-list-search-result-info>
            <session-search></session-search>
          </div>
        </div>
      </div>

      <div class="filter-option"
        [ngClass]="{ 'no-feedback-hold': selectedService.getGroup().hasPresenterRole() || !shouldShowFeedbackHold()}"
        filter-view-options-bar
        [hidden]="dataSourceZeroState.hasZeroState">
        <div class="search-container">
          <session-list-search-result-info></session-list-search-result-info>
          <session-search></session-search>
        </div>
        <toggle-grid-list-view></toggle-grid-list-view>
      </div>

      @if (!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading) {
        <div class="filter-content"
          filter-view-content
          (contextmenu)="openMenu($event)">
          @if (hasSessions$ | async; as hasSessions) {
            @if ((shouldShowTestBailedView$ | async) !== true) {
              @if (currentView === views.LIST) {
                <div class="list-view">
                  <session-table
                    (goToSession)="openSession($event)">
                  </session-table>
                </div>
              }
              @if (currentView === views.GRID) {
                <div class="grid-view">
                  <session-grid
                    (openSession)="openSession($event)">
                  </session-grid>
                </div>
              }
            } @else {
              <ngx-zero-state class="zero-state-single-attempt-activity" data-cy="bailed-test">
                <p zero-state-title translate="session-list_zero-state-bailed-test-title"></p>
                <p zero-state-subtext translate="session-list_zero-state-bailed-test-subtext"></p>
              </ngx-zero-state>
            }
          } @else {
            <session-zero-state
              (startActivity)="preStartActivity()"
              (viewInstructions)="viewInstructions()">
            </session-zero-state>
          }

          @if ((canStartActivity$$ | async) && !selectedService.getActivity().isConversationBoard()) {
            <menu>
              <activity-context-menu
                (viewInstructions)="viewInstructions()"
                [canStartActivity]="canStartActivity$$ | async"
              (onStartActivity)="preStartActivity()"></activity-context-menu>
            </menu>
          }
        </div>
      }

      <!-- Datasource zero state -->
      <div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
        <data-source-zero-state [dataSource]="sessionListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
      </div>

      <div class="filter-action"
        filter-view-action-bar
        [hidden]="dataSourceZeroState.hasZeroState">
        @if (shouldShowFooterButtons$ | async) {
          <button
            class="link-btn view-instructions-btn"
            (click)="viewInstructions()"
            [attr.aria-label]="'session-zero-state_view_instructions' | translate">
            <span class="regular">{{ 'session-zero-state_view_instructions' | translate }}</span>
            <span class="shortened">{{ 'session-zero-state_view_instructions_shortened' | translate}}</span>
          </button>
          @if (canInvite()) {
            <button
              class="secondary-btn invite-btn"
              (click)="openInviteModal()"
              translate>
              common_invite
            </button>
          }
          @if (!selectedService.getActivity().isConversationBoard()) {
            <button
              type="button"
              class="btn primary-btn start-activity-btn"
              data-cy="add-video"
              (click)="preStartActivity()"
              [disabled]="(canStartActivity$$ | async) === false"
              disabledInteractive
              [matTooltip]="getSessionCreationDisabledMessage$$ | async"
              [matTooltipDisabled]="canStartActivity$$ | async"
              matTooltipPosition="above"
              [attr.aria-label]="'session-zero-state_start-activity' | translate">
              <span class="regular">{{ 'session-zero-state_start-activity' | translate }}</span>
              <span class="shortened">{{ 'session-zero-state_start-activity_shortened' | translate}}</span>
            </button>
          }
        }
      </div>
    </filter-view-layout>
  }
}
